import { MainNavSection } from '../../../models/mainnav';
import {
  menuItem_NoticesAndBriefs,
  menuItem_Resources,
  menuItem_FAQ,
  menuItem_Deliverables,
  menuItem_TestEvidence,
  menuItem_Accreditation,
  menuItem_TestResults,
  menuItem_Contact,
} from './MenuItems';
import { MenuGroupLabels } from './MenuGroupLabels';

export const Services_Australia_Menu: MainNavSection[] = [
  {
    label: MenuGroupLabels.INFO,
    navItems: [
      menuItem_NoticesAndBriefs,
      menuItem_Resources,
      menuItem_FAQ,
      menuItem_Contact,
    ],
  },
  {
    label: MenuGroupLabels.ADMIN_TASKS,
    navItems: [
      menuItem_Deliverables,
      menuItem_TestEvidence,
      menuItem_TestResults,
      menuItem_Accreditation,
    ],
  },
];
